import { forwardRef } from 'react';
import * as AccessibleIcon from '@radix-ui/react-accessible-icon';
import CloserIcon from '@components/icons/CloserIcon/CloserIcon';
import BackArrowButton from '@components/icons/BackArrowButton/BackArrowButton';

import styles from './CloseButton.module.scss';

const Button = forwardRef<HTMLButtonElement>(({ children, ...props }, forwardedRef) => (
  <AccessibleIcon.Root label="Chiudi">
    <button className={styles.CloseButton} aria-label="Close" {...props} ref={forwardedRef}>
      <div className={styles.hiddenMobile}>
        <CloserIcon width={19} height={19} />
      </div>
      <div className={styles.hiddenDesktop}>
        <BackArrowButton />
      </div>
    </button>
  </AccessibleIcon.Root>
));

Button.displayName = 'CloseButton';

export const CloseButton = Button;
